export default __webpack_public_path__ + "static/media/blacklist.fc0effe3.svg";